import * as styles from "./atom.scrambled.style";

export function Scrambled(): React.JSX.Element {
  return (
    <div className={styles.scrambled}>
      <div className={styles.container}>
        <svg
          className={styles.icon}
          version="1.1"
          viewBox="0 0 28 38.7"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M7,13.5c0.3,0,0.5-0.2,0.5-0.5v-1.7C7.8,11.2,8,10.9,8,10.5c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.4,0.2,0.7,0.5,0.8V13C6.5,13.3,6.7,13.5,7,13.5z M7,10.5C7,10.5,7,10.5,7,10.5C7,10.5,7,10.5,7,10.5l-0.5,0L7,10.5z" />
            <path d="M13,8v4.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C14,7.2,13.8,7,13.5,7H12V5c0-2.8-2.2-5-5-5S2,2.2,2,5v2H0.5C0.2,7,0,7.2,0,7.5v10C0,17.8,0.2,18,0.5,18h1C1.8,18,2,17.8,2,17.5S1.8,17,1.5,17H1V8H13z M3,5c0-2.2,1.8-4,4-4s4,1.8,4,4v2H3V5z" />
            <path d="M27.5,14.7h-23C4.2,14.7,4,15,4,15.2v23c0,0.3,0.2,0.5,0.5,0.5h23c0.3,0,0.5-0.2,0.5-0.5v-23C28,15,27.8,14.7,27.5,14.7z M27,15.7v16h-0.7l-3.4-6.8c-0.4-0.7-1.1-1.2-1.9-1.2c-0.8,0-1.5,0.4-2,1.1l-2.6,4.5c-0.8-0.9-2.4-2.6-4.4-2.6c-2.5,0-4.3,3.8-4.8,5H5v-16H27z M25.2,31.7H8.3c0.7-1.5,2.2-4,3.7-4c2.2,0,4.1,2.8,4.1,2.8c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l3-5.2c0.2-0.4,0.6-0.6,1.1-0.6c0.4,0,0.8,0.3,1,0.7L25.2,31.7z M5,37.7v-5h22v5H5z" />
            <path d="M10.5,23.7h3c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2c-0.5,0-0.9,0.1-1.3,0.3c-0.5,0.4-0.9,1-0.9,1.7C8.5,22.8,9.4,23.7,10.5,23.7z M9.9,20.9c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.4,0.1c0.1,0.1,0.3,0,0.4,0s0.2-0.2,0.2-0.4c0.2-1,1-1.7,2-1.7c1.1,0,2,0.9,2,2s-0.9,2-2,2h-3c-0.6,0-1-0.4-1-1C9.5,21.4,9.7,21.1,9.9,20.9z" />
          </g>
        </svg>
      </div>
    </div>
  );
}
